import getStore from '../store/store';
import { mutatorAction } from 'satcheljs';
/**
 * Mutator to load shared calendars option store
 */
export default mutatorAction('updateSharedCalendarsInitialState', function updateSharedCalendarsInitialState(data) {
    var store = getStore();
    store.calendars = data.calendars;
    store.initialState = data.initialState;
    store.currentState = data.currentState;
});
//# sourceMappingURL=updateSharedCalendarsInitialState.js.map